<template>
  <SuppliersFormReact
    :open="isOpen"
    :mode="mode"
    :defaultValues="resource"
    :onClose="handleClose"
    :onCancel="handleCancel"
    :onCreated="handleCreated"
    :onUpdated="handleUpdated"
  />
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { SuppliersFormController } from "@/modules/suppliers/components/SuppliersFormController";

const SuppliersFormReact = ReactInVue(SuppliersFormController);

const normalizeResource = (resource = {}) => ({
  id: resource.id || resource._id || "",
  name: resource.name || "",
  taxNumber: resource.taxNumber || resource.nif || "",
  description: resource.description || "",
  phone: resource.phone || "",
  email: resource.email || "",
  street: resource.street || "",
  city: resource.city || "",
  location: resource.location || "",
  zipCode: resource.zipCode || "",
  country: resource.country || "",
});

export default {
  name: "SuppliersForm",
  components: {
    SuppliersFormReact,
  },
  data() {
    return {
      isOpen: false,
      mode: "create",
      resource: normalizeResource(),
    };
  },
  methods: {
    show(val = true) {
      this.isOpen = val;
      if (!val) {
        this.reset();
      }
    },
    setResource(resource = {}) {
      this.resource = normalizeResource(resource);
      this.mode = this.resource.id ? "edit" : "create";
    },
    reset() {
      this.mode = "create";
      this.resource = normalizeResource();
    },
    handleCreated(supplier) {
      this.$emit("created", supplier);
    },
    handleUpdated(supplier) {
      this.$emit("updated", supplier);
    },
    handleCancel() {
      this.$emit("canceled");
    },
    handleClose() {
      this.isOpen = false;
      this.reset();
    },
  },
};
</script>
